import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';

// project imports
import config from './../config';
import { ROUTES } from '../constants';

//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    const token = localStorage.getItem('token');
    const defaultPath = token ? ROUTES.CONTRACT.BASE : config.defaultPath;
    return (
        <Switch>
            <Redirect exact from="/" to={defaultPath} />
            <React.Fragment>
                <MainRoutes />
            </React.Fragment>
        </Switch>
    );
};

export default Routes;
